function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var isSANB = require(160);
function handleFormOnPopstate(ev) {
  var state = ev.originalEvent.state;

  // Get forms and filter out any that are inside of the table
  // as they will be reloaded when form is submitted
  var $forms = $(".table-ajax-form").filter(function () {
    var $this = $(this);
    var $table = $($this.data('table'));
    return !$.contains($table.get(0), this);
  });

  // Return early if there is no forms
  if ($forms.length === 0) return;
  var $unmodifiedForms = [];
  var $modifiedForms = [];

  // Iterate thru search params for each form and set values
  $forms.each(function () {
    var $this = $(this);
    var isModified = false;

    // Data search-params should be a ',' delimited string
    var searchParameters = $this.data('search-params');
    searchParameters = isSANB(searchParameters) ? searchParameters.split(',') : [];
    var _iterator = _createForOfIteratorHelper(searchParameters),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var $input = $this.find("[name=".concat(key, "]"));
        if (state) {
          $input.val(state[key]);
          if (state[key]) isModified = true;
        } else {
          $input.val(undefined);
        }
      }

      // Sort form for modification after reloading table
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (isModified) $modifiedForms.push($this);else $unmodifiedForms.push($this);
  });

  // Submit form
  $forms.first().submit();

  // Fix modified forms
  for (var _i = 0, _$modifiedForms = $modifiedForms; _i < _$modifiedForms.length; _i++) {
    var $f = _$modifiedForms[_i];
    $f.data('modified', true);
  }
  for (var _i2 = 0, _$unmodifiedForms = $unmodifiedForms; _i2 < _$unmodifiedForms.length; _i2++) {
    var _$f = _$unmodifiedForms[_i2];
    _$f.data('modified', false);
  }
}
module.exports = handleFormOnPopstate;
//# sourceMappingURL=handle-form-on-popstate.js.map